import axios from 'axios';
import BlumarConfig from '../blumar-config';
import store from '../store/store';

export default function executeInterceptor() {
  axios.defaults.baseURL = BlumarConfig.baseWebserviceUrl;

  axios.defaults.headers = {
    "Access-Key": BlumarConfig.paymentWebserviceAccessKey
  };

  axios.interceptors.request.use(config => {
    store.dispatch('showLoading', true);
    return config;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });

  axios.interceptors.response.use(response => {
    store.dispatch('showLoading', false);
    return response;
  }, error => {
    store.dispatch('showLoading', false);
    return Promise.reject(error);
  });


};



// WEBPACK FOOTER //
// ./src/services/HttpHelper.js